<template>
    <!-- navbar -->
    <nav class="navbar navbar-expand-lg navbar-light fixed w-full top-0 left-0 bg-white opacity-100 z-40" style="background-color: #ffffff;  ">
        <a class="navbar-brand " href="/" style="color: #ffffff;">

        <!-- <img :src="getImage()"  alt=""  width="50%"/> -->

        <!-- <img class="img-fluid" src="require('/assets/imgs/aruvaa_logo.png')" width="50%"> -->
         <img :src="'/imgs/aruvaa_logo.png'" class="img-fluid img_size" alt="" >
        </a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse mr-5" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
               
            </ul>
            <form class="form-inline my-2 my-lg-0">
               
                <div v-if="$page.props.user">
                        <!-- <a v-bind:href="'https://account.'+this.tenantHostName+'/dashboard'" class="search-button pt-1 pb-0 pl-2 pr-2" > -->
                        <!-- <a :href="route('dashboard')" class="menu py-1 px-2 rounded" >
                        Account
                        </a> -->

                        <a href="#" class="menu py-1 px-2 rounded" >
                        Account
                        </a>
                </div>

            <div v-else>
                <a  :href="route('login')"   class="menu p-1 py-1 px-2 ml-2 rounded">
                Log in   
                </a>
                
                <a v-if="canRegister" :href="route('register')"  class="menu p-1 py-1 px-2 ml-2 rounded">
                        Register
                </a>
                    
            </div>

                      
            </form>
        </div> 
    </nav>
    <!-- navbar --> 
</template>

<script>
   import { Head, Link } from '@inertiajs/inertia-vue3';

      let api_url = process.env.APP_URL;
    export default {
      
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
          
        },
        
         data() {
        return {
              canRegister:true,
              tenantHostName:null,

            ///url: '/', 
        }
    }
    ,
    mounted(){
        
        this.tenantHostName = window.location.hostname ;
       // console.log("tenantHostName"+this.tenantHostName);
    }
    
    
    }
</script>


<style scoped>
 :root {
        --blue: #0068CA;
        --white: #ffffff;
        --primary: #82C5FF;
        --secondary: #FDC031;
        --black: #333333;
        --input_grey: #d7d7d7;
        --hint_grey: #bfbfbf;
        --pink: #FF4B69;
    }
    * {
        outline: none;
    }
   
.img_size{
    height: auto;
    width: 97px;
}
    /*Scroll - START*/
    /* width */
    ::-webkit-scrollbar {
        width: 5px;
    }
    /* Track */
    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }
    /* Handle */
    ::-webkit-scrollbar-thumb {
        background: #888;
    }
    /* Handle on hover */
    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
    /*Scroll - END*/
    /* .nav-link-header {
        color: #9c761f !important;
        font-weight: 650 !important;
        font-size: 16px;
    } */

    .nav-link-header {
      color: #9c761f !important;
      font-weight: 650 !important;
      font-size: 16px;
      position: relative;
      text-decoration: none; /* Remove underline */
      padding-bottom: 4px; /* Space for the underline */
    }

    .nav-link-header::after {
      content: '';
      position: absolute;
      width: 60%;
      margin: auto 14px;
      height: 2px; /* Height of the underline */
      background-color: #9c761f; /* Color of the underline */
      left: 0;
      bottom: 0;
      transform: scaleX(0);
      transform-origin: bottom right;
      transition: transform 0.3s ease-out;
    }

    .nav-link-header:hover::after {
      transform: scaleX(1);
      transform-origin: bottom left;
    }
   
    .support-dashboard-container {
        background-color: #0068CA;
        color: var(--white);
    }
    .menu {
        font-style: normal;
        font-weight: 700;
        margin-left: 4px;
        color: #021f7e;
        font-size: 15px;
    }
    .menu:hover {
        color: #001969;
        font-weight: 700;
        font-style: normal;
        font-size: 15px;
    }
    .category-container {
        font-size: 14px;
        border: 1px solid var(--blue);
        height: 100px;
        color: var(--black);
        transition: 0.2s;
    }
    .category-container:hover {
        box-shadow: 0 0 4px 1px var(--blue);
    }
    .category-container-link:hover {
        text-decoration: none;
    }

    /* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
    .navbar-brand{
      margin-left: 0rem;  
    }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 600px) {
    .navbar-brand{
      margin-left: 1rem;  
    }
} 

/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
     .navbar-brand{
      margin-left: 2rem;  
    }
}

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {
     .navbar-brand{
      margin-left: 3rem;  
    }
}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
    .navbar-brand{
      margin-left: 3rem;  
    }
} 
.navbar {
  position: fixed !important;
  display: flex;
  align-items: center;
  padding: 0rem 0rem;
}

</style>

